import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  lista: (tipo) => {
    return Vue.http.get(`/api/contratos/${tipo}/tiposcontrato`).then(resposta => resposta.body);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/tipo-contrato/servico.js